/**
 * Transform
 *
 *   module.exports.a = *;
 *
 * to
 *
 *   export const a = *;
 *
 * Only on global context
 */

import Logger from "./utils/logger";
import { isTopNode } from "./utils/filters";

function transformer(file, api, options) {
    const j = api.jscodeshift;
    const _isTopNode = (path) => isTopNode(j, path);
    const logger = new Logger(file, options);

    // ------------------------------------------------------------------ SEARCH
    // https://astexplorer.net/#/gist/334f5bd39244c7feab38a3fd3cc0ce7f/c332a5b4cbd1a9718e644febf2dce9e9bd032d1b
    const ast = j(file.source)
    const moduleExportNodes = ast
        .find(j.ExpressionStatement, {
            expression: {
                left: {
                    object: {
                        object: {
                            name: "module"
                        },
                        property: {
                            name: "exports"
                        }
                    }
                    // property is target
                },
                operator: "="
            }
        })
        .filter(_isTopNode);

    const exportNodes = ast
        .find(j.ExpressionStatement, {
            expression: {
                left: {
                    object: {
                        name: "exports"
                    }
                    // property is target
                },
                operator: "="
            }
        })
        .filter(_isTopNode);

    logger.log(`${moduleExportNodes.length + exportNodes.length} nodes will be transformed`);
    // ----------------------------------------------------------------- REPLACE
    const replace = (path) => {
        const node = path.node;
        // Identifier node
        const id = node.expression.left.property;
        const init = node.expression.right;
        // module.export.b = a
        // → export { a as b }
        if (id.type === "Identifier" && init.type === "Identifier") {
            const newNode = j.exportNamedDeclaration(null, [j.exportSpecifier.from({ exported: id, local: init })]);
            newNode.comments = node.comments;
            return newNode;
        }
        // https://babeljs.io/docs/en/babel-types#exportnameddeclaration
        const declaration = j.variableDeclaration("const", [j.variableDeclarator(id, init)]);
        const newNode = j.exportNamedDeclaration(declaration);
        newNode.comments = node.comments;
        return newNode;
    };

    exportNodes
        .replaceWith(replace)
    moduleExportNodes
        .replaceWith(replace)
    return ast.toSource();
}

export default transformer;
